var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "stepOut" }, [
    _c("div", { staticClass: "stepItem" }, [
      _c("p", { class: _vm.stepInfo.status >= 1 ? "blue" : "gray" }, [
        _vm._v("售后申请"),
      ]),
      _c("p", { staticClass: "time" }, [
        _vm._v(_vm._s(_vm.stepInfo.applyTime)),
      ]),
      _vm.stepInfo.status == 7
        ? _c(
            "div",
            { staticClass: "stepItem_xian" },
            [
              _vm._l(3, function (item, index) {
                return _c("div", [_c("div", { staticClass: "dot2" })])
              }),
              _vm._l(3, function (item, index) {
                return _c("div", [_c("div", { staticClass: "dot1" })])
              }),
            ],
            2
          )
        : _c(
            "div",
            { staticClass: "stepItem_xian" },
            _vm._l(6, function (item, index) {
              return _c("div", [_c("div", { staticClass: "dot" })])
            }),
            0
          ),
      _vm.stepInfo.status == 7 ? _c("div", { staticClass: "dots" }) : _vm._e(),
      _vm.stepInfo.status == 7
        ? _c("div", { staticClass: "info" }, [_vm._v("申请已取消")])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "stepItem shenheStatus" }, [
      _c(
        "p",
        {
          class:
            _vm.stepInfo.status >= 1 &&
            _vm.stepInfo.status != 7 &&
            _vm.stepInfo.status != 1
              ? "blue"
              : "gray",
        },
        [_vm._v(" 审核申请 ")]
      ),
      _c("p", { staticClass: "time" }, [
        _vm._v(_vm._s(_vm.stepInfo.auditTime)),
      ]),
      _vm.stepInfo.status == 2
        ? _c(
            "div",
            { staticClass: "stepItem_xian" },
            [
              _vm._l(3, function (item, index) {
                return _c("div", [_c("div", { staticClass: "dot2" })])
              }),
              _vm._l(3, function (item, index) {
                return _c("div", [_c("div", { staticClass: "dot1" })])
              }),
            ],
            2
          )
        : _vm._e(),
      _vm.stepInfo.status == 7 || _vm.stepInfo.status == 1
        ? _c(
            "div",
            { staticClass: "stepItem_xian" },
            _vm._l(6, function (item, index) {
              return _c("div", [_c("div", { staticClass: "dot1" })])
            }),
            0
          )
        : _vm._e(),
      _vm.stepInfo.status == 8 ||
      _vm.stepInfo.status == 3 ||
      _vm.stepInfo.status == 4
        ? _c(
            "div",
            { staticClass: "stepItem_xian" },
            _vm._l(6, function (item, index) {
              return _c("div", [_c("div", { staticClass: "dot" })])
            }),
            0
          )
        : _vm._e(),
      _vm.stepInfo.status == 2 ? _c("div", { staticClass: "dots" }) : _vm._e(),
      _vm.stepInfo.status == 2
        ? _c("div", { staticClass: "info" }, [_vm._v("申请已驳回")])
        : _vm._e(),
      _vm.statustype == 3 ? _c("div", { staticClass: "close" }) : _vm._e(),
    ]),
    _c("div", { staticClass: "stepItem" }, [
      _c(
        "p",
        {
          class:
            _vm.stepInfo.status == 8 || _vm.stepInfo.status == 4
              ? "blue"
              : "gray",
        },
        [_vm._v(" 买家寄回 ")]
      ),
      _c("p", { staticClass: "time" }, [
        _vm._v(_vm._s(_vm.stepInfo.sendBackTime)),
      ]),
      _vm.stepInfo.status == 1 ||
      _vm.stepInfo.status == 7 ||
      _vm.stepInfo.status == 2 ||
      _vm.stepInfo.status == 3
        ? _c(
            "div",
            { staticClass: "stepItem_xian" },
            _vm._l(6, function (item, index) {
              return _c("div", [_c("div", { staticClass: "dot1" })])
            }),
            0
          )
        : _vm._e(),
      _vm.stepInfo.status == 8 || _vm.stepInfo.status == 4
        ? _c(
            "div",
            { staticClass: "stepItem_xian" },
            _vm._l(6, function (item, index) {
              return _c("div", [_c("div", { staticClass: "dot" })])
            }),
            0
          )
        : _vm._e(),
      _vm.stepInfo.status == 8 || _vm.stepInfo.status == 4
        ? _c("div", { staticClass: "dots1" })
        : _vm._e(),
      _vm.stepInfo.status == 8 || _vm.stepInfo.status == 4
        ? _c(
            "div",
            { staticClass: "info1" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.examine(1)
                    },
                  },
                },
                [_vm._v("查看物流")]
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _c("div", { staticClass: "stepItem" }, [
      _c(
        "p",
        {
          class:
            _vm.stepInfo.status >= 1 && _vm.stepInfo.status == 8
              ? "blue"
              : "gray",
        },
        [_vm._v(" 售后完成 ")]
      ),
      _c("p", { staticClass: "time" }, [
        _vm._v(_vm._s(_vm.stepInfo.completeTime)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }